import { useTranslation } from 'react-i18next'

import { updateRentalPortalListing } from '../../../../../../../api'
import { useNotification } from '../../../../../../../hooks'
import {
  getHasListingLivePublications,
  getIsListingChangedConflictError,
  getListingConflictVersion,
  getListingEditConflictNotification,
  getListingResyncDisclosureModal,
  getListingUnitLabel,
  LISTING_EDIT_CONFLICT_NOTIFICATION_ID,
} from '../../../../../../RentalPortalListing'
import { useListingProfileContext } from '../../../RentalPortalListingProfile.hooks'

import { getListingProfileBlockSaveErrors } from './useListingProfileBlockSave.utils'

export function useListingProfileBlockSave({
  onClose,
  onRemoveNotification,
  onSetNotification,
}) {
  const { t } = useTranslation()

  const { handleAddSuccessNotification } = useNotification()

  const { handleCloseModal, handleEntityReload, listingData, setModal } =
    useListingProfileContext()

  function handleClickReload() {
    onRemoveNotification(LISTING_EDIT_CONFLICT_NOTIFICATION_ID)

    onClose()

    handleEntityReload()
  }

  async function saveBlock({ formikHelpers, payload, version, onSuccess }) {
    try {
      await updateRentalPortalListing({
        data: payload,
        id: listingData.id,
        version,
      })

      await handleEntityReload().catch(console.error)

      handleAddSuccessNotification('Notification.CommonTitleSavedKey')

      formikHelpers.setSubmitting(false)

      onSuccess()
    } catch (error) {
      formikHelpers.setSubmitting(false)

      if (getIsListingChangedConflictError(error)) {
        handleSaveConflict({ error, formikHelpers, payload, onSuccess })
      } else {
        formikHelpers.setErrors(getListingProfileBlockSaveErrors({ error, t }))
      }
    }
  }

  function handleSaveConflict({ error, formikHelpers, payload, onSuccess }) {
    function handleClickOverwrite() {
      onRemoveNotification(LISTING_EDIT_CONFLICT_NOTIFICATION_ID)

      formikHelpers.setSubmitting(true)

      saveBlock({
        formikHelpers,
        payload,
        version: getListingConflictVersion(error),
        onSuccess,
      })
    }

    onSetNotification(
      getListingEditConflictNotification({
        error,
        t,
        onClickOverwrite: handleClickOverwrite,
        onClickReload: handleClickReload,
      })
    )
  }

  function handleDismissResyncDisclosure(setSubmitting) {
    handleCloseModal()
    setSubmitting(false)
  }

  function handleSaveBlock({ formikHelpers, payload, onSuccess }) {
    if (getHasListingLivePublications(listingData)) {
      setModal(
        getListingResyncDisclosureModal({
          listingName: getListingUnitLabel({ listing: listingData, t }),
          t,
          onDismiss: () =>
            handleDismissResyncDisclosure(formikHelpers.setSubmitting),
          onSubmit: () => {
            handleCloseModal()
            saveBlock({
              formikHelpers,
              payload,
              version: listingData.version,
              onSuccess,
            })
          },
        })
      )
    } else {
      saveBlock({
        formikHelpers,
        payload,
        version: listingData.version,
        onSuccess,
      })
    }
  }

  return { handleSaveBlock }
}
